/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type LinkedInAccountResponseStatus = typeof LinkedInAccountResponseStatus[keyof typeof LinkedInAccountResponseStatus];


export const LinkedInAccountResponseStatus = {
  connecting: 'connecting',
  connected: 'connected',
  needs_reconnect: 'needs_reconnect',
  disconnected: 'disconnected',
} as const;
